// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
//require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("../js/jquery.easy-autocomplete.min")
require("../packs/search")

import "../css/application.scss";

// import Swiper from "swiper";
var Swiper = require("../js/swiper-bundle.min")
global.$ = global.Swiper = Swiper;
window.$ = window.Swiper = Swiper;

var jQuery = require('jquery')

global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

import "bootstrap";
// import "../packs/search";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)
